// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-muted{color:#9b9b9b}.vx-modal-profile{background-image:linear-gradient(to top, #3a293d, #232337);padding:0;border-radius:0.8rem;max-width:42rem}.vx-modal-profile.vx-react-modal{width:100%;max-width:42rem}\n", ""]);
// Exports
module.exports = exports;
